import { DataViewProvider as DataViewProviderPackage } from '@chipinside/dataview'
import { PropsWithChildren } from 'react'
import { toast } from 'sonner'

import { Dialog } from '#/components/Dialog'
import FormatCell from '#/components/FormatCell'
import { formatCellAllowProps } from '#/components/FormatCell/allowProps'
import LinearLoader from '#/components/Loader/Linear'
import QuickInfo from '#/components/QuickInfo'
import PageError from '#/pages/Fallback/PageError'
import { useFarmName } from '#/store/ducks/farm'
import { listeners } from '#/utils/listeners'

export function DataViewProvider({ children }: PropsWithChildren) {
  const farmName = useFarmName()

  return (
    <DataViewProviderPackage
      components={{
        FormatCell: props => <FormatCell {...props} />,
        Loader: props => <LinearLoader {...props} />,
        PageError: ({ code }) => <PageError code={code} />,
        QuickInfo: props => <QuickInfo {...props} />,
      }}
      constants={{
        farmName,
        // TODO: mover para o pacote isso quando o datagrid for removido
        formatCellAllowProps,
        listener: listeners.datagrid,
      }}
      functions={{
        closeDialog: () => Dialog.close(),
        openDialog: options => Dialog.open(options),
        toast,
      }}
    >
      {children}
    </DataViewProviderPackage>
  )
}
